export default "__VITE_ASSET__Bj7LHlR8__"